import { yup } from '@guiker/yup-util'

export const template = yup
  .object({
    uid: yup.string().required(),
    name: yup.string().required(),
  })
  .required()
